<section *ngIf="locationsArray.length > 0" class="space-pb popup-gallery overflowx-h" style="position:relative;padding-top:30px;background-color:#F6F6F6;">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="section-title">
          <h2>Recommended Sho't Left</h2>
          <div> 
            <span style="background-color:#F6F6F6;"> Heita! So, you want to get out there and you’re looking for something great within your budget. Here are some of the hottest deals for stays and activities to suit the kind of experience you’re looking for. It’s your country, Enjoy it!
            </span>
          </div>
        </div>
      </div>
    </div>
    
      
      <div class="col-12">
        <div class="carousel-wrapper">

        <button class="custom-nav-button prev-button" (click)="prevSlide()">
              <i class="fas fa-solid fa-arrow-left"></i>
        </button>
        <div class="carousel-container">
        <owl-carousel-o #owlCarousel [options]="customOptions" >
          <ng-container *ngFor="let loc of locationsArray ; let i = index">
            <ng-template carouselSlide [id]="">
            <div class="location-item-02 bg-holder text-center"
              style="background-image: url({{loc.cf_images[0]?.mx_image}});border-top-left-radius:6%;border-top-right-radius:6%;height:150px;">
              
              <!--<div *ngIf="loc.cf_discount != '0'" class="Specialdiscount">&nbsp;&nbsp;&nbsp;&nbsp;{{loc.cf_discount}}% Off&nbsp;&nbsp;&nbsp;&nbsp;</div>-->
              <div *ngIf="loc.cf_price === loc.cf_newPrice" class="NowPrice">
                          &nbsp;&nbsp;&nbsp;&nbsp;{{ loc.cf_currency }} {{ loc.cf_price }}&nbsp;&nbsp;&nbsp;&nbsp;    
              </div>
              <div *ngIf="loc.cf_price !== loc.cf_newPrice">
                <div class="Specialdiscount strikethrough-text">
                  &nbsp;&nbsp;Was {{ loc.cf_currency }} {{ loc.cf_price }}&nbsp;&nbsp;&nbsp;
                </div>
                <div class="NowPrice">
                  &nbsp;&nbsp;Now {{ loc.cf_currency }} {{ loc.cf_newPrice }}&nbsp;&nbsp;
                </div>
              </div>
              
              
              
              <div class="listing-image" style=" margin-left: 60%;">
                <!-- <div class="listing-quick-box-small">
                  <a class="like" style="margin-left:50px;cursor:pointer;" data-toggle="tooltip" data-placement="top"
                    title="Like"> <i class="fa fa-plus-circle"></i> </a>
                </div> -->
               
                <!-- <a class="like" style="margin-left:8px;cursor:pointer;" data-toggle="tooltip" data-placement="top" title="Like"> <i class="fas fa-heart"></i> </a>  -->

                <!-- <div class="listing-quick-box-custom-small">
                  <a style="margin-left:8px;cursor:pointer;" data-toggle="tooltip" data-placement="top" title="food"> <i
                      class="fas fa-utensils"></i> </a>
                  <a style="margin-left:10px;cursor:pointer;" data-toggle="tooltip" data-placement="top" title="plane">
                    <i class="fas fa-plane"></i> </a>
                  <a style="margin-left:8px;cursor:pointer;" data-toggle="tooltip" data-placement="top" title="bus"> <i
                      class="fas fa-bus"></i> </a>
                  <a style="margin-left:10px;cursor:pointer;" data-toggle="tooltip" data-placement="top" title="hotel">
                    <i class="fas fa-hotel"></i> </a>
                </div> -->
              </div>
            </div>
            <div class="listing-item">
              <div class="listing-details">
                <div class="listing-details-inner-small">
                  <div class="listing-title">
                    <h6><a>{{loc.title.substring(0,60)}}</a></h6>
                  </div>
                  <div class="listing-info">
                    <div class="mb-0">{{loc.cf_deal_summary.substring(0,200)}}</div>
                  </div>
                  <br />
                </div>
                <div>
                    <app-pill> {{ loc.cf_priceCategory }}</app-pill>
                    <app-pill> {{ loc.cf_experience_desc }} </app-pill>
                    <a class="iconsyellow social-share" data-toggle="tooltip" data-placement="top" title="Share">
                              <i class="fas fa-share-alt"></i>
                              <div class="social-box">
                               <!-- <a target="_blank" [href]="facebook" aria-label="Share on Facebook">
                                  <i class="fab fa-facebook-f"></i>
                                </a>
                                &nbsp;
                                <a target="_blank" [href]="twitter + loc.title" aria-label="Share on X">
                                  <i class="fa-brands fa-x-twitter"></i>
                                </a>
                                &nbsp;
                                <a [href]="'mailto:?subject=South African Tourism: ' + loc.title + '&body=' + loc.cf_deal_description + ' ' + break + ' ' + email" 
                                  aria-label="Share via Email">
                                  <i class="fas fa-envelope"></i>
                                </a>
                                &nbsp;-->
                                <a target="_blank" [href]="whatsapp + loc.url_title"  aria-label="Share on Whatsapp">
                                  <i class="fa-brands fa-whatsapp">&nbsp;</i>
                                </a> 
                              </div>
                    </a>
                </div>
                <div class="listing-bottom">
                  <!--<div class="col-6 text-left listing-shotleft">
                    <a class="listing-price">ZAR {{loc.cf_price}}</a>
                  </div>-->
                  <div class="col-12 text-right listing-shotright">
                    <a (click)="goToDeals(loc.url_title)" class="listing-open">Explore more ></a>
                  </div>
                </div>
              </div>
            </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
        </div>
        <!--Right Navigation-->
        <button class="custom-nav-button next-button" (click)="nextSlide()">
          <i class="fas fa-solid fa-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
</section>